import { apiRequest } from '../../lib/api-client.js';

export interface AiSettings {
  enabled: boolean;
  provider: 'gemini' | 'openai';
  model: string;
  prompt: string;
  timeout_ms: number;
  /** A chave nunca vem pra tela — só se existe uma guardada. */
  has_key: boolean;
  /** Por fornecedor: a tela precisa dizer se falta colar a do escolhido. */
  has_key_gemini: boolean;
  has_key_openai: boolean;
  propagated_at: string | null;
  updated_at: string | null;
}

export interface AiSettingsInput {
  enabled: boolean;
  provider: 'gemini' | 'openai';
  model: string;
  /** Só mande quando o operador digitar uma chave nova. */
  api_key?: string;
  prompt: string;
  timeout_ms?: number;
}

export interface PropagateResult {
  servers: Array<{
    server_id: number;
    server_name: string;
    ok: boolean;
    detail: string;
  }>;
}

export interface ListaDeModelos {
  models: string[];
}

export interface CasoDoTeste {
  nome: string;
  ok: boolean;
  entrada: string;
  texto?: string;
  ms: number;
  tokens_in?: number;
  tokens_out?: number;
  /** Números do original que não sobreviveram — o erro que mais importa. */
  numeros_perdidos?: string[];
  erro?: string;
}

export interface ResultadoDoTeste {
  ok: boolean;
  /** Motivo já traduzido pra algo acionável (quando falhou). */
  erro?: string;
  ms?: number;
  tokens_in?: number;
  tokens_out?: number;
  casos?: CasoDoTeste[];
}

export interface TesteInput {
  provider?: 'gemini' | 'openai';
  model?: string;
  api_key?: string;
  prompt?: string;
}

export const aiApi = {
  /** Manda um texto de exemplo pra IA com a config informada (ou a guardada). */
  test: (input: TesteInput = {}) =>
    apiRequest<ResultadoDoTeste>('/api/ai-settings/test', { method: 'POST', body: input }),
  /** Modelos disponíveis para escolha (lista fixa no servidor). */
  models: (provider?: 'gemini' | 'openai') =>
    apiRequest<ListaDeModelos>(
      `/api/ai-settings/models${provider ? `?provider=${provider}` : ''}`,
    ),
  get: () => apiRequest<AiSettings>('/api/ai-settings'),
  save: (input: AiSettingsInput) =>
    apiRequest<{ ok: true }>('/api/ai-settings', { method: 'PUT', body: input }),
  propagate: () =>
    apiRequest<PropagateResult>('/api/ai-settings/propagate', { method: 'POST' }),
};
